import React, { useState, useEffect } from 'react';
import styles from '../styles/WorksPage.module.css';
import WireframeBackground from '../components/WireframeBackground';
import { fetchData } from '../utils/apiClient';

const mockWorks = [
    {
        id: 1,
        title: '『数分間のエールを』',
        description: '劇場版アニメーションのキャラクター・プロップリグ制作',
        type: 'image',
        url: '/works/REC.jpg',
        category: 'Movie',
        date: '2024-06-14'
    },
    {
        id: 2,
        title: '「BUMP OF CHICKEN Sleep Walking Orchestra」',
        description: 'MV用キャラクターリグ制作',
        type: 'video',
        url: 'https://www.youtube.com/embed/RqooLet7B2Q?si=t1a3v-IfZWPeLIMO',
        category: 'Music Video',
        date: '2024-01-11'
    },
    {
        id: 5,
        title: 'メルカリCM『超メルカリ市』（クーポン15秒編）',
        description: 'キャラクターリグ制作',
        type: 'image',
        url: '/works/mercari.jpg',
        category: 'Advertisement',
        date: '2024-08-25'
    },
    {
        id: 6,
        title: 'Demo Reel',
        description: '2023年に作成したデモリールです。',
        type: 'video',
        url: 'https://www.youtube.com/embed/zlAobUb7pWw?si=GaN5vPbm0DYP376r',
        category: 'demo reel',
        date: '2023-04-02'
    },
    {
        id: 7,
        title: 'Motion Capture Demo Reel',
        description: 'モーションキャプチャーを用いたダンスモーション映像のデモリールです。',
        type: 'video',
        url: 'https://www.youtube.com/embed/ncZxPlgRipk?si=aoU80bFuWUyzkpDf',
        category: 'demo reel',
        date: '2023-05-01'
    },
    {
        id: 10,
        title: '遊技機CGキャラクターリグ仕様策定＆量産',
        description: 'セルルックキャラクターアニメーション用の遊技機セットアップの仕様策定から量産まで自社で対応致しました。',
        type: 'image',
        url: '/images/VRchara_web_normal.png',
        category: 'Slot',
        date: '2024-11-30'
    },
    {
        id: 11,
        title: 'MV『Number_i - GOD_i』',
        description: 'MVエフェクト用のモデルセットアップ',
        type: 'video',
        url: 'https://www.youtube.com/embed/mDFNuDfijCc?si=V36tBjOWLIT7tiZI',
        category: 'Music video',
        date: '2025-01-20'
    },
    {
        id: 12,
        title: 'サントリー天然水×ハローキティ『もしもの水備え隊』',
        description: 'キャラクターセットアップ',
        type: 'image',
        url: '/images/suntory2.jpg',
        category: 'CM',
        date: '2025-03-22'
    },
    {
        id: 13,
        title: 'Mrs. GREEN APPLE「クスシキ」Official Music Video',
        description: 'ロトスコ作業（リグ・アニメーション）',
        type: 'video',
        url: 'https://www.youtube.com/embed/RCaTLn4qoz4?si=enQ4zQhhbv9-Dz4w',
        category: 'MV',
        date: '2025-04-05'
    },
    {
        id: 14,
        title: 'YouTubeテーマソング2 / ヒカキン&セイキン',
        description: 'YouTubeテーマソング2のCGパートのリギング・モーションを担当しました。',
        type: 'video',
        url: 'https://www.youtube.com/embed/sDdUy2EHN7o?si=cxZ8vuoDI58VpelA',
        category: 'Music Video',
        date: '2025-08-26'
    },
    {
        id: 15,
        title: 'So-net CM 乃木坂46×So-net「光の糸」篇 / SONY',
        description: 'CGモーションの一部を担当しました。',
        type: 'video',
        url: 'https://www.youtube.com/embed/EdNc_Dicfq0?si=ZVTwdenyxj-0MtCi',
        category: 'CM',
        date: '2025-09-16'
    },
    {
        id: 20,
        title: '【トヨタ キッズモビ】コンセプトムービー',
        description: 'Japan Mobility Show2025のトヨタブース出展『Kids Mobi』のコンセプトムービーのリードリギング・モーション一部を担当しました。',
        type: 'video',
        url: 'https://www.youtube.com/embed/fsx4DGuCvCM?si=2lCGK2y02PHttAVb',
        category: 'Concept Movie',
        date: '2025-12-25'
    }
];

function WorksPage() {
    // モックデータも日付による降順（新しい順）でソートしておく
    const sortedMockWorks = [...mockWorks].sort((a, b) => new Date(b.date) - new Date(a.date));
    const [works, setWorks] = useState(sortedMockWorks);
    const [selectedWork, setSelectedWork] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchWorks = async () => {
            try {
                const data = await fetchData('/api/getWorks.php');
                if (data.status === 'success' && data.data.length > 0) {
                    setWorks(data.data);
                }
            } catch (err) {
                console.warn("API取得失敗。モックデータを使用します。");
            } finally {
                setLoading(false);
            }
        };
        fetchWorks();
    }, []);

    const isMobile = () => window.innerWidth <= 768;

    const handleCardClick = (work) => {
        if (isMobile() && work.type === 'video') {
            window.open(work.url.replace('embed/', 'watch?v='), '_blank');
        } else {
            setSelectedWork(work);
        }
    };

    const closePopup = () => setSelectedWork(null);

    const tools = [
        { name: 'Maya', logo: '/tools/maya.png' },
        // { name: '3ds Max', logo: '/tools/3dsmax.png' },
        // { name: 'Unity', logo: '/tools/unity.png' },
        // { name: 'Blender', logo: '/tools/blender.png' }
    ];

    if (loading) return null;

    return (
        <div className={styles.container}>
            <WireframeBackground />
            <div className={styles.wrap}>
                <section className={styles.worksSection}>
                    <div className={styles.header}>
                        <h2 className={styles.sectionTitle}>WORKS</h2>
                        <p className={styles.subtitle}>制作実績</p>
                    </div>

                    <div className={styles.worksGrid}>
                        {works.map((work, index) => (
                            <div
                                key={index}
                                className={styles.workCard}
                                onClick={() => handleCardClick(work)}
                            >
                                <div className={styles.cornerTL}></div>
                                <div className={styles.cornerTR}></div>
                                <div className={styles.cornerBL}></div>
                                <div className={styles.cornerBR}></div>

                                <div className={styles.mediaWrapper}>
                                    {work.type === 'video' ? (
                                        <div className={styles.videoPlaceholder}>
                                            <img
                                                src={`https://img.youtube.com/vi/${work.url.split('/embed/')[1]?.split('?')[0]}/0.jpg`}
                                                alt={work.title}
                                                className={styles.workImage}
                                            />
                                            <div className={styles.playIcon}>▶</div>
                                        </div>
                                    ) : (
                                        <img src={work.url} alt={work.title} className={styles.workImage} />
                                    )}
                                </div>

                                <div className={styles.workDetails}>
                                    <p className={styles.workCategory}>{work.category}</p>
                                    <h3 className={styles.workTitle}>{work.title}</h3>
                                    <p className={styles.workDate}>{work.date}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className={styles.toolsSection}>
                        <h3 className={styles.sectionTitle}>CORE TOOLS</h3>
                        <div className={styles.toolsGrid}>
                            {tools.map((tool, index) => (
                                <div key={index} className={styles.toolCard}>
                                    <div className={styles.toolIconWrapper}>
                                        <img src={tool.logo} alt={tool.name} className={styles.toolLogo} />
                                    </div>
                                    <p className={styles.toolName}>{tool.name}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            </div>

            {selectedWork && (
                <div className={styles.popupOverlay} onClick={closePopup}>
                    <div className={styles.popupContent} onClick={(e) => e.stopPropagation()}>
                        <div className={styles.cornerTL}></div>
                        <div className={styles.cornerTR}></div>
                        <div className={styles.cornerBL}></div>
                        <div className={styles.cornerBR}></div>

                        <button className={styles.closeButton} onClick={closePopup}>×</button>

                        <div className={styles.popupMedia}>
                            {selectedWork.type === 'video' ? (
                                <iframe
                                    className={styles.popupVideo}
                                    src={`${selectedWork.url}${selectedWork.url.includes('?') ? '&' : '?'}autoplay=1`}
                                    title={selectedWork.title}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                ></iframe>
                            ) : (
                                <img src={selectedWork.url} alt={selectedWork.title} className={styles.popupImage} />
                            )}
                        </div>

                        <div className={styles.popupInfo}>
                            <p className={styles.popupCategory}>{selectedWork.category}</p>
                            <h3 className={styles.popupTitle}>{selectedWork.title}</h3>
                            <div className={styles.popupDivider}></div>
                            <p className={styles.popupDescription}>{selectedWork.description}</p>
                            <p className={styles.popupDate}>{selectedWork.date}</p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default WorksPage;
